export default function ViabilityScoreCardMock() {
  const score = 53;
  const grade = 'C';
  const radius = 44;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;

  const dimensions = [
    { label: 'Profitability', value: 20, max: 25, color: '#22c55e' },
    { label: 'Risk Management', value: 17, max: 25, color: '#3b82f6' },
    { label: 'Consistency', value: 6, max: 25, color: '#eab308' },
    { label: 'Robustness', value: 10, max: 25, color: '#a855f7' },
  ];

  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" style={{ background: '#9d4edd' }} /> Viability Score</div>
      <div className="platform-mock-body" style={{ padding: '1rem 1.25rem', display: 'flex', gap: '1.25rem', alignItems: 'flex-start' }}>
        {/* Circular gauge */}
        <div style={{ flexShrink: 0, position: 'relative', width: 100, height: 100 }}>
          <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%', transform: 'rotate(-90deg)' }}>
            <circle cx="50" cy="50" r={radius} fill="none" stroke="#1f2937" strokeWidth="8" />
            <circle
              cx="50" cy="50" r={radius}
              fill="none" stroke="#eab308" strokeWidth="8"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
            />
          </svg>
          <div style={{
            position: 'absolute', inset: 0,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          }}>
            <span style={{ fontSize: '1.5rem', fontWeight: 800, color: '#eab308' }}>{grade}</span>
            <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>{score}/100</span>
          </div>
        </div>

        {/* Dimension breakdown */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {dimensions.map((d, i) => (
            <div key={i} style={{ marginBottom: i < dimensions.length - 1 ? '0.5rem' : 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.625rem', color: '#9ca3af', marginBottom: 2 }}>
                <span>{d.label}</span>
                <span style={{ fontFamily: 'monospace', fontWeight: 600 }}>{d.value}/{d.max}</span>
              </div>
              <div style={{ height: 6, background: '#1f2937', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{
                  width: `${(d.value / d.max) * 100}%`,
                  height: '100%',
                  background: d.color,
                  borderRadius: 3,
                }} />
              </div>
            </div>
          ))}

          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginTop: '0.625rem' }}>
            {['Profitable', 'Moderate DD', 'Low consistency'].map((tag, i) => (
              <span key={i} style={{
                fontSize: '0.5625rem',
                padding: '2px 6px',
                borderRadius: 4,
                background: '#1f2937',
                color: '#6b7280',
              }}>
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">
        The Viability Score distills all metrics into a single 0-100 grade across four weighted dimensions.
      </div>
    </div>
  );
}
